import { resourceImageReferenceZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/resource-image-reference";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { unitZodSchema } from "@@/shared/units-and-quantities/unit";
import { z } from "zod";
import { resourceIdFactory, resourceIdZodSchema } from "./resource-id";
import { resourceLinkZodSchema } from "./resource-link";
import { resourceMapConnectionZodSchema } from "./resource-map-connection";

const resourceGroupZodObject = z.object({
    _id: resourceIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("RESOURCE_GROUP"),
    meta: metaContentZodSchema,
    unit: unitZodSchema,
    ownerId: providerIdZodSchema,
    resources: z.array(resourceLinkZodSchema),
    resourceMapConnection: resourceMapConnectionZodSchema.optional(),
    imageRefs: z.array(resourceImageReferenceZodObject).optional(),
});

type ResourceGroup = z.infer<typeof resourceGroupZodObject>;
type ResourceGroupType = ResourceGroup["_type"];
const _resourceGroupFactoryParamsZodObject = resourceGroupZodObject
    .omit({
        _id: true,
        _createdAt: true,
        _type: true,
    })
    .and(z.object({ _id: resourceIdZodSchema.optional() }));
type FactoryParams = z.infer<typeof _resourceGroupFactoryParamsZodObject>;
const resourceGroupFactory = (params: FactoryParams): ResourceGroup => {
    return {
        _id: resourceIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "RESOURCE_GROUP",
        ...params,
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResourceGroup = (item: any): item is ResourceGroup =>
    item && item._type === "RESOURCE_GROUP";
const isNotResourceGroup = <T>(
    item: T | undefined,
): item is Exclude<T, ResourceGroup> => !isResourceGroup(item);
export {
    isNotResourceGroup,
    isResourceGroup,
    resourceGroupFactory,
    resourceGroupZodObject,
};
export type { ResourceGroup, ResourceGroupType };
